import Lang from '/@/modules/core/app/services/Lang';
import { InventoryType } from '@/modules/inventory/enums/InventoryType';
import { Color } from '@/modules/core/app/enums/Color';

export class LiabilityType extends InventoryType {
  static LOAN_AND_CREDIT_PAYMENT: LiabilityType = {
    key: 'loan_and_credit_payment',
    get value() {
      return Lang.t('liability.loan-credit-payments');
    },
    color: Color.PEWTER_BLUE,
    icon: 'saving-bank'
  };

  static UNPAID_TAX: LiabilityType = {
    key: 'unpaid_tax',
    get value() {
      return Lang.t('liability.unpaid-taxes');
    },
    color: Color.CHERRY_RED,
    icon: 'official-building'
  };

  static PERSONAL_EXPENSE: LiabilityType = {
    key: 'personal_expense',
    get value() {
      return Lang.t('liability.personal-expenses');
    },
    color: Color.PUMPKIN_ORANGE,
    icon: 'single-neutral-actions-money'
  };

  static ESTATE_EXPENSE: LiabilityType = {
    key: 'estate_expense',
    get value() {
      return Lang.t('liability.funeral-estate-expenses');
    },
    color: Color.FRESH_GREEN,
    icon: 'flower'
  };

  static OTHER_CREDITOR: LiabilityType = {
    key: 'other_creditor',
    get value() {
      return Lang.t('liability.other-creditors');
    },
    color: Color.LILAC_PINK,
    icon: 'single-neutral-briefcase'
  };

  static EXECUTOR_DISBURSEMENT: LiabilityType = {
    key: 'executor_disbursement',
    get value() {
      return Lang.t('liability.executor-disbursements');
    },
    color: Color.PERIWINKLE_BLUE,
    icon: 'multiple-actions-money'
  };

  static EXECUTOR_COMPENSATION: LiabilityType = {
    key: 'executor_compensation',
    get value() {
      return Lang.t('liability.executor-compensations');
    },
    color: Color.DEEP_MAROON,
    icon: 'cash-payment-bag'
  };

  static ATTORNEY_COMPENSATION: LiabilityType = {
    key: 'attorney_compensation',
    get value() {
      return Lang.t('liability.attorney-compensations');
    },
    color: Color.DEEP_MAROON,
    icon: 'cash-payment-bag'
  };

  static ESTIMATED_FINAL_TAXES: LiabilityType = {
    key: 'estimated_final_taxes',
    get value() {
      return Lang.t('liability.estimated-final-taxes');
    },
    color: Color.PEWTER_BLUE,
    icon: 'official-building'
  };

  static POTENTIAL_SPOUSE_CLAIM: LiabilityType = {
    key: 'potential_spouse_claim',
    get value() {
      return Lang.t('liability.potential-spouse-claim');
    },
    color: Color.SPICY_RED,
    icon: 'cash-payment-bag'
  };

  static getAdvisorPortalInventoryTypes(): LiabilityType[] {
    return [this.LOAN_AND_CREDIT_PAYMENT, this.OTHER_CREDITOR];
  }

  static getTypesWithRecurringOption(): LiabilityType[] {
    return [
      this.PERSONAL_EXPENSE,
      this.ESTATE_EXPENSE,
      this.OTHER_CREDITOR,
      this.EXECUTOR_COMPENSATION
    ].map((type: LiabilityType) => ({ ...type }));
  }

  static canAssignCoOwners(type: string): boolean {
    return [this.LOAN_AND_CREDIT_PAYMENT.key, this.UNPAID_TAX.key].includes(type);
  }
}
